import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import type { BookingRow } from '../lib/types';

export function DashboardPage() {
  const bookings = useQuery({
    queryKey: ['bookings', 'all-recent'],
    queryFn: () => api.listBookings({ limit: 5 }),
  });

  const newOnly = useQuery({
    queryKey: ['bookings', 'new'],
    queryFn: () => api.listBookings({ status: 'new', limit: 0 }),
  });

  return (
    <div>
      <h1 style={{ fontSize: 24, marginBottom: 4 }}>Обзор</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>Сводка по заявкам и ценам</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 32 }}>
        <Stat label="Новые заявки" value={newOnly.data?.total ?? '—'} color="var(--info)" />
        <Stat label="Всего заявок" value={bookings.data?.total ?? '—'} color="var(--primary)" />
      </div>

      <div className="card" style={{ padding: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h2 style={{ fontSize: 18 }}>Последние заявки</h2>
          <Link to="/bookings" style={{ color: 'var(--accent)', fontSize: 14, fontWeight: 600 }}>
            Все →
          </Link>
        </div>
        {bookings.isLoading && <div style={{ color: 'var(--text-muted)' }}>Загрузка…</div>}
        {bookings.data && bookings.data.items.length === 0 && (
          <div style={{ color: 'var(--text-muted)' }}>Заявок пока нет.</div>
        )}
        <ul style={{ listStyle: 'none', display: 'grid', gap: 8 }}>
          {bookings.data?.items.map((raw) => {
            const b = raw as BookingRow;
            return (
              <li key={b.id}>
                <Link
                  to={`/bookings/${b.id}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px 12px',
                    borderRadius: 8,
                    border: '1px solid var(--border-light)',
                    gap: 12,
                  }}
                >
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ fontWeight: 600 }}>{b.name}</div>
                    <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
                      {b.phone} · {new Date(b.createdAt).toLocaleString('ru')}
                    </div>
                  </div>
                  <span className={`badge badge-${b.status}`}>{b.status}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

function Stat({ label, value, color }: { label: string; value: number | string; color: string }) {
  return (
    <div className="card" style={{ padding: 18 }}>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: 0.5 }}>
        {label}
      </div>
      <div style={{ fontSize: 28, fontWeight: 800, color, marginTop: 4 }}>{value}</div>
    </div>
  );
}
